module.exports = __webpack_public_path__ + "static/media/decors.bc165d30.png";